import Vue from "vue";
import Router from "vue-router";
import Footer from "./layout/Footer";
import Apply from "./views/apply.vue";

Vue.use(Router);

export default new Router({
  mode: 'history', // 這裡改成 history
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "apply",
      components: {
        default: Apply,
        footer: Footer
      }
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
